module.exports = __webpack_public_path__ + "img/logo.7f783b24.png";